if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
        this.mobileThumbnailButtons = Array.from(this.querySelectorAll('[data-mobile-media-id]'));

        this.querySelector('[data-mobile-modal-previous]')?.addEventListener('click', () => {
          this.showAdjacentMobileMedia(-1);
        });
        this.querySelector('[data-mobile-modal-next]')?.addEventListener('click', () => {
          this.showAdjacentMobileMedia(1);
        });
        this.mobileThumbnailButtons.forEach((button) => {
          button.addEventListener('click', () => this.setActiveMobileMedia(button.dataset.mobileMediaId));
        });

        this.querySelectorAll('.product-media-modal__mobile-navigation, .product-media-modal__mobile-thumbnails').forEach(
          (control) => control.addEventListener('pointerup', (event) => event.stopPropagation())
        );
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const activeMediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${activeMediaId}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${activeMediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');

        const container = this.querySelector('[role="document"]');
        if (this.mobileMediaQuery.matches) {
          container.scrollTop = 0;
          container.scrollLeft = 0;
          this.updateMobileControls(activeMediaId);
        } else {
          activeMedia.scrollIntoView();
          container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;
        }

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }

      showAdjacentMobileMedia(direction) {
        if (!this.mobileMediaQuery.matches || this.mobileThumbnailButtons.length < 2) return;

        const activeIndex = this.mobileThumbnailButtons.findIndex((button) => button.hasAttribute('aria-current'));
        const nextIndex = (activeIndex + direction + this.mobileThumbnailButtons.length) % this.mobileThumbnailButtons.length;
        this.setActiveMobileMedia(this.mobileThumbnailButtons[nextIndex].dataset.mobileMediaId);
      }

      setActiveMobileMedia(mediaId) {
        if (!this.mobileMediaQuery.matches) return;

        const activeMedia = this.querySelector(`.product-media-modal__content > [data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        window.pauseAllMedia();
        this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach((media) => {
          media.classList.toggle('active', media === activeMedia);
        });
        this.updateMobileControls(mediaId);
      }

      updateMobileControls(mediaId) {
        const activeThumbnail = this.mobileThumbnailButtons.find((button) => button.dataset.mobileMediaId === mediaId);
        if (!activeThumbnail) return;

        this.mobileThumbnailButtons.forEach((button) => {
          if (button === activeThumbnail) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        });
        const thumbnailStrip = activeThumbnail.closest('.product-media-modal__mobile-thumbnails');
        if (thumbnailStrip) {
          const centeredPosition = activeThumbnail.offsetLeft - (thumbnailStrip.clientWidth - activeThumbnail.offsetWidth) / 2;
          thumbnailStrip.scrollTo({ left: Math.max(0, centeredPosition), behavior: 'smooth' });
        }

        const status = this.querySelector('[data-mobile-modal-status]');
        if (status) status.textContent = activeThumbnail.getAttribute('aria-label');
      }
    }
  );
}
